import { render, staticRenderFns } from "./AppFilterSection.vue?vue&type=template&id=2f4b7069&scoped=true"
import script from "./AppFilterSection.vue?vue&type=script&lang=js"
export * from "./AppFilterSection.vue?vue&type=script&lang=js"
import style0 from "./AppFilterSection.vue?vue&type=style&index=0&id=2f4b7069&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4b7069",
  null
  
)

export default component.exports